import * as Sentry from '@sentry/react';

/**
 * Sentry frontend. VITE_SENTRY_DSN vazio = no-op.
 * Inclui Replay (10% sessions, 100% errors) + Tracing.
 */
let initialized = false;

export function initSentry(): void {
  if (initialized) return;
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) {
    initialized = true;
    return;
  }
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllInputs: true })],
  });
  initialized = true;
}

export function captureException(err: unknown, context?: Record<string, unknown>): void {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  Sentry.withScope((scope) => {
    if (context) Object.entries(context).forEach(([k, v]) => scope.setExtra(k, v));
    Sentry.captureException(err);
  });
}

export function setUser(user: { id?: string; email?: string } | null): void {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  Sentry.setUser(user);
}
